import { Col, Row, Button, notification, Spin, Modal } from 'antd'
import React, { useEffect, useRef, useState } from 'react'
import { ChosePayment } from './ChosePayment';
import { useTranslation } from 'react-i18next';
import { BillInformation } from './BillInformation';
import { errorHandling } from '../../../config/AuthIntercept';
import { EsidPaidAllInv, EsidUpdOrderId, EsidUpdPayMode } from '../../../config/esidExportApi';
import { payWithoutOTP } from '../../../config/checkinApi';
import { useDispatch, useSelector } from 'react-redux';
import { setPaymentInfo } from '../../../actions/payment';
import { useHistory, useLocation } from 'react-router-dom';
import { EsidStatusEnum } from '../../../constant/enumerations';
import { ReceiptDetail } from './ReceiptDetail';
import { TcbCheckPayment, TcbGetQR } from '../../../config/tcbQrPayment';
import moment from 'moment';
import { EXP_PFX } from '../../../config/Constant';

export const EsidPaymentInfo = ({ handlePrevTab, invoicesDetail, chkLoadData, isFetchData, fetchData }) => {
  const { t } = useTranslation("common");
  const token = useSelector((state) => state.userAwb.token) || '';
  const selectEsidExport = useSelector(state => state.esidExport.esidExpSelected);
  const [checkedOption, setCheckedOption] = useState('WEB');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  const [qrModalVisible, setQrModalVisible] = useState(false);
  const [qrResult, setQrResult] = useState(null);
  const [expiresTime, setExpiresTime] = useState({days: 0, hours: 0, minutes: 10, seconds: 0});
  const [paymentStatus, setPaymentStatus] = useState('PENDING');

  const checkExtend = useRef(30); // số lần check trạng thái thanh toán còn lại
  const holdCheckPayment = useRef(false); // biến giữ trạng thái đang check thanh toán
  const checkCountdown = useRef(true); // biến giữ trạng thái countdown

  useEffect(() => {
    if (!qrResult?.order_information?.order_duration) {
      return;
    }
    const duration = qrResult.order_information.order_duration;
    // Giả sử duration có định dạng "30"
    // countdown từ duration phút
    let totalSeconds = parseInt(duration) * 60;
    const interval = setInterval(() => {
      checkCountdown.current = true;
      const days = Math.floor(totalSeconds / (24 * 3600));
      const hours = Math.floor((totalSeconds % (24 * 3600)) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      setExpiresTime({ days, hours, minutes, seconds });
      if (totalSeconds <= 0) {
        checkExtend.current = 30;
        checkCountdown.current = false;
        clearInterval(interval);
        notification.info({
          message: 'Mã QR đã hết hạn. Vui lòng thử lại!',
        });
      }
      totalSeconds--;
    }, 1000);

    // check payment
    const checkQRConfirm = async () => {
      if (!qrResult || !qrResult.transaction_log_id) {
        notification.error({
          message: 'Lỗi khi kiểm tra trạng thái thanh toán! Vui lòng thử lại!',
        });
        clearInterval(backgoundSyncInterval);
        return;
      }
      const inputRequest = {
        transactionLogId: qrResult.transaction_log_id,
      };
      try {
        if (checkExtend.current <= 0) {
          clearInterval(backgoundSyncInterval);
          setQrModalVisible(false);
          notification.info({
            message: 'Mã QR đã hết hạn. Vui lòng thử lại!',
          });
          return;
        }
        if (!checkCountdown.current) {
          checkExtend.current = checkExtend.current - 1;
        }
        if (holdCheckPayment.current) {
          return;
        }
        holdCheckPayment.current = true;
        var result = await TcbCheckPayment(inputRequest, token);
        if (result.data) {
          const transferSyntax = getTransferSyntax(checkedOption)
          setPaymentStatus(result.data.transaction_status?.toLocaleUpperCase());
          if (result.data.transaction_status?.toLocaleUpperCase() === 'SUCCESS') {
            // const updateOrderIdRes = await EsidUpdOrderId(
            //   {
            //     ...chkLoadData,
            //     WEB_PMT_MOD: 'WQR',
            //     SND_PAY_STR: transferSyntax,
            //     RCV_BNK_TRS_CD1: qrResult.transaction_log_id,
            //   }
            // );
            const updateOrderIdRes = await EsidPaidAllInv(
              {
                ...chkLoadData,
                WEB_PMT_MOD: 'WQR',
                SND_PAY_STR: transferSyntax,
                RCV_DAT: result.data.processing_date ?? moment().format('YYYY/MM/DD HH:mm:ss'),
                RCV_BNK_AMT: result.data.transaction_amount,
                RCV_BNK_TRS_COD: result.data.destination_account_number,
                COD_CUR: result.data.currency,
                SND_PAY_DAT: result.data.created_date,
                BNK_COD: `${qrResult.transaction_log_id}#${chkLoadData.TABLE_ID}#${result.data.transaction_status}#`,
                RCV_BNK_STR: result.data.payment_description,
                BNK_NAM: result.data.sender_account_name,
              }
            );
            if (updateOrderIdRes.data) {
              setQrModalVisible(false);
              await fetchData();
              notification.success({
                message: 'Thanh toán thành công!',
              });
              clearInterval(backgoundSyncInterval);
            } else {
              notification.error({
                message: 'Lỗi khi kiểm tra trạng thái thanh toán! Vui lòng thử lại!',
              });
              clearInterval(backgoundSyncInterval);
            }
          }
        } else {
          console.log('Chưa thanh toán: ', result.data);
        }
        holdCheckPayment.current = false;
      } catch (error) {
        console.log(error);
        return;
      }
    };
    // sau 3s kiểm tra trạng thái thanh toán
    const backgoundSyncInterval = setInterval(() => {
      checkQRConfirm();
    }, 3 * 1000); // 3s

    return () => {
      clearInterval(interval);
      clearInterval(backgoundSyncInterval);
    };
    // eslint-disable-next-line
  }, [qrResult, checkedOption]);

  useEffect(() => {
    const checkPaymentStatus = async () => {
      if (
        !chkLoadData?.RCV_BNK_TRS_CD1 ||
        !chkLoadData?.WEB_PMT_MOD !== 'WQR' ||
        ['FN', 'OK'].includes(chkLoadData?.COD_STS)
      ) {
        return;
      }
      try {
        const inputRequest = {
          transactionLogId: chkLoadData.RCV_BNK_TRS_CD1,
        };
        var result = await TcbCheckPayment(inputRequest, token);
        if (result.data) {
          if (result.data.transaction_status?.toLocaleUpperCase() === 'SUCCESS') {
            await EsidPaidAllInv({
              ...chkLoadData,
              WEB_PMT_MOD: 'WQR',
              SND_PAY_STR: getTransferSyntax('WQR'),
              RCV_DAT: result.data.processing_date ?? moment().format('YYYY/MM/DD HH:mm:ss'),
              RCV_BNK_AMT: result.data.transaction_amount,
              RCV_BNK_TRS_COD: result.data.destination_account_number,
              COD_CUR: result.data.currency,
              SND_PAY_DAT: result.data.created_date,
              BNK_COD: `${chkLoadData.RCV_BNK_TRS_CD1}#${chkLoadData.TABLE_ID}#${result.data.transaction_status}#`,
              RCV_BNK_STR: result.data.payment_description,
              BNK_NAM: result.data.sender_account_name,
            });
          }
        }
      } catch (error) {}
    };

    checkPaymentStatus();
    // eslint-disable-next-line
  }, [chkLoadData]);

  const issueEInvoice = async () => {
    window.open('http://e-invoice.tcs.com.vn/', '_blank').focus();
    // try {
    //   await EsidIssueEInvoice(chkLoadData);
    //   await fetchData();
    //   if (chkLoadData.COD_STS === "AP") {
    //     notification.error({
    //       message: "Vui lòng thử lại sau!",
    //     });
    //   }
    //   else if (chkLoadData.COD_STS === 'FN' || chkLoadData.COD_STS === 'OK') {
    //     notification.info({
    //       message: "Hóa đơn điện tử đã xuất"
    //     })
    //   }
    //   else {
    //     notification.success({
    //       message: "Đã xuất hóa đơn thành công!",
    //     });
    //   }
    // } catch (error) {
    //   if (error.response.status === 401) {
    //     notification.error({
    //       message: t("home.sessionNoti"),
    //     });
    //     dispatch(userAwbLogout());
    //     dispatch(setMAWB({}));
    //     localStorage.removeItem("userAWB");
    //     localStorage.removeItem("MAWB");
    //     history.push("/");
    //   } else
    //     notification.error({
    //       message: "Lỗi",
    //     });
    // }
  };
  const isEqualSts = (codSts, acceptedStsArr) => {
    if ( acceptedStsArr.includes(codSts) ) {
      return true;
    }
    return false;
  }
  const handleCheckout = async () => {
    const transferSyntax = getTransferSyntax(checkedOption)
    try {
      setIsSubmitting(true);
      await EsidUpdPayMode({
        ...chkLoadData,
        WEB_PMT_MOD: checkedOption,
        SND_PAY_STR: transferSyntax,
        COD_STS: chkLoadData?.COD_STS === 'AM' ? 'AC' : chkLoadData?.COD_STS // Thanh toán lại
      })

      if ( checkedOption === 'WEB' ) {
        const payRes = await payWithoutOTP(
          chkLoadData.AMT_TOT,
          "VND",
          `TCSEXP_${chkLoadData.TABLE_ID}`,
          transferSyntax,
          token 
        );
        if (payRes.status === 200 && payRes.data) {
          dispatch(
            setPaymentInfo({
              ...payRes.data,
              FLG_IMP_EXP: chkLoadData.FLG_IMP_EXP,
              orderRef: transferSyntax,
              isHawb: false,
            })
          );
          localStorage.setItem(
            "pInfo",
            JSON.stringify({
              ...payRes.data,
              FLG_IMP_EXP: chkLoadData.FLG_IMP_EXP,
              orderRef: transferSyntax,
              isHawb: false,
            })
          );
          localStorage.setItem(
            "esidExp",
            JSON.stringify({
              ...selectEsidExport
            })
          );
          if (chkLoadData.TABLE_ID) {
            localStorage.setItem('chk_id', chkLoadData.TABLE_ID);
          }
          const updateOrderIdRes = await EsidUpdOrderId(
            {
              ...chkLoadData,
              RCV_BNK_TRS_CD1: payRes.data.order.id,
            },
          );
          if (updateOrderIdRes.data) {
            notification.success({
              message: "Đã cập nhật phương thức thanh toán!",
            });
            history.push(`/napas/checkout`);
            fetchData();
          } else {
            notification.error({
              message: "Lỗi! Vui lòng thử lại!",
            });
          }
        }
      }
      else if ( checkedOption === 'WQR' ) {
        var qrCodeData = {
          orderID: `${EXP_PFX}${chkLoadData.TABLE_ID.toString()}`,
          amount: chkLoadData.AMT_CSH_INV,
          currency: 'VND',
          orderDescription: transferSyntax,
          orderNarrative: `WQRCSE ${chkLoadData.CNE_CODE} P${chkLoadData.TABLE_ID}`,
        };
        const qrCodeRes = await TcbGetQR(qrCodeData, token);
        if (qrCodeRes.status === 200 && qrCodeRes.data) {
          await EsidUpdOrderId(
            {
              ...chkLoadData,
              WEB_PMT_MOD: 'WQR',
              SND_PAY_STR: transferSyntax,
              RCV_BNK_TRS_CD1: qrCodeRes.data.transaction_log_id,
            }
          );
          setQrModalVisible(true);
          setQrResult(qrCodeRes.data);
        } else {
          notification.error({
            message: 'Lỗi khi lấy mã QR! Vui lòng thử lại!',
          });
        }
        setIsSubmitting(false);
      }
      else {
        notification.info({
          message: "Payment not supported yet",
        });
      }
    } catch (error) {
      errorHandling(error, history, location.pathname);
    } finally {
      setIsSubmitting(false);
    }
  }
  const getTransferSyntax = (paymentOpt) => {
    switch (paymentOpt) {
      case "CSH":
        return `EXP ${chkLoadData.TABLE_ID.toString().padStart(8, 0)} KHACH HANG ${chkLoadData.CNE_CODE} THANH TOAN ${chkLoadData.AMT_TOT} VND TIEN DICH VU AWB ${chkLoadData.COD_AWB_PFX}${chkLoadData.COD_AWB_NUM}`
      case "WQR":
        return `EXP ${chkLoadData.TABLE_ID.toString().padStart(8, 0)} KHACH HANG ${chkLoadData.CNE_CODE} THANH TOAN ${chkLoadData.AMT_TOT} VND TIEN DICH VU AWB ${chkLoadData.COD_AWB_PFX}${chkLoadData.COD_AWB_NUM}`
      case "WEB":
        return `EXP ${chkLoadData.TABLE_ID.toString().padStart(8, 0)} KHACH HANG ${chkLoadData.CNE_CODE} THANH TOAN ${chkLoadData.AMT_TOT} VND TIEN DICH VU AWB ${chkLoadData.COD_AWB_PFX}${chkLoadData.COD_AWB_NUM}`
      default:
        return ""
    }
  }

  const handleCancelQrModal = () => {
    if (paymentStatus !== 'SUCCESS') {
      Modal.confirm({
        title: 'Xác nhận',
        content: 'Giao dịch chưa hoàn tất. Bạn có chắc chắn muốn đóng?',
        okText: 'Đồng ý',
        cancelText: 'Hủy',
        onOk: () => {
          setQrModalVisible(false);
        },
      });
      return;
    }
    setQrModalVisible(false);
  };

  return (
    <Spin spinning={isFetchData} tip={t("esidCheckout.paymentTab.chosePaymentSubTitle")}>
      <div style={{ maxWidth: 1300, marginInline: 'auto'} }>
        <Row gutter={[30,10]} style={{marginBlock: 40, width: '100%' }}>
            {
              chkLoadData && 
                isEqualSts(
                  chkLoadData.COD_STS, 
                  [EsidStatusEnum.AP, EsidStatusEnum.QR, EsidStatusEnum.FN, EsidStatusEnum.OK]
                ) ? (
                  <>
                    <Col span={24}>
                      <div style={{ width: '100%', gap: 5, display: 'flex', justifyContent: 'flex-end'}}>
                        <Button onClick={issueEInvoice} style={{ width: 'fit-content'}}>{t("esidCheckout.exportEInvBtn")}</Button>
                      </div>
                    </Col>
                    <Col xs={24} sm={24} md={14}>
                      <ReceiptDetail chkLoadData={chkLoadData}/>
                    </Col>
                  </>
                ) : (
                <Col xs={24} sm={24} md={14}>
                  <ChosePayment checkedOption={checkedOption} setCheckedOption={setCheckedOption} />
                  <Row style={{ margin: 20 }}>
                    {
                      chkLoadData && 
                        !isEqualSts(
                          chkLoadData.COD_STS, 
                          [EsidStatusEnum.AP, EsidStatusEnum.QR, EsidStatusEnum.FN, EsidStatusEnum.OK]
                        ) && (
                          <Col span={24}>
                            <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginBlock: 10}}>
                              <Button 
                                loading={isSubmitting} 
                                style={{ width: 'fit-content'}}
                                onClick={handleCheckout}>
                                {t("esidCheckout.nextBtn")}
                              </Button>
                            </div>
                          </Col>
                        )
                    }
                  </Row>
                </Col>
                )
            }
            <Col xs={24} sm={24} md={10}>
              <BillInformation handlePrevTab={handlePrevTab} invoicesDetail={invoicesDetail}/>
            </Col>
            {/* <Col xs={24} sm={24} md={12}>
              <PaymentDetail invoicesDetail={invoicesDetail}/>
            </Col> */}
            {/* {
              chkLoadData && 
                !isEqualSts(
                  chkLoadData.COD_STS, 
                  [EsidStatusEnum.AP, EsidStatusEnum.QR, EsidStatusEnum.FN, EsidStatusEnum.OK]
                ) && (
                  <Col span={24}>
                    <div style={{ width: '50%', display: 'flex', justifyContent: 'center', marginBlock: 10}}>
                      <Button 
                        loading={isSubmitting} 
                        style={{ width: 'fit-content'}}
                        onClick={handleCheckout}>
                        {t("esidCheckout.nextBtn_TT")}
                      </Button>
                    </div>
                  </Col>
                )
            } */}
        </Row>
      {/* <ModalSelectMethod visible={true} /> */}
        {qrModalVisible && (
          <Modal
            centered
            width={'400px'}
            title={'Thanh toán'}
            visible={qrModalVisible}
            onCancel={handleCancelQrModal}
            footer={[<Button disabled={paymentStatus !== 'SUCCESS'} onClick={handleCancelQrModal}>Đóng</Button>]}>
            {paymentStatus === 'SUCCESS' ? (
              <div>
                <h2 style={{ color: 'green' }}>Thanh toán thành công!</h2>
                <h3 style={{ color: 'green' }}>Hệ thống đang hoàn tất các bước xử lý, vui lòng chờ trong giây lát!</h3>
              </div>
            ) : (
              <>
                <h2 style={{ color: '#ffa401' }}>Vui lòng quét mã QR để thanh toán</h2>
                {expiresTime.minutes === 0 && expiresTime.seconds === 0 ? (
                  <h3 style={{ color: 'red' }}>Mã QR đã hết hạn. Vui lòng thử lại!</h3>
                ) : (
                  <h3 style={{ color: 'red' }}>
                    Mã QR sẽ hết hạn sau: {`${expiresTime.minutes} phút ${expiresTime.seconds} giây`}
                  </h3>
                )}
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  {/* HIển thị hình ảnh qr từ base64 */}
                  {qrResult && (
                    <img
                      src={`data:image/png;base64,${qrResult?.order_information?.tqr_code_base64}`}
                      alt="QR Code"
                      width={300}
                      height={300}
                    />
                  )}
                </div>
                <h3 style={{  color: 'red' }}>Vui lòng giữ màn hình mở cho đến khi giao dịch hoàn tất.</h3>
              </>
            )}
          </Modal>
        )}
      </div>
    </Spin>
  )
}
